import service from '../api/type.service';
//constants
const dataType = {
    types: [],
    lsType: [],
    concepts: [],
    createType: [],
    deleteType: [],
    updateType: [],
    errorType: '',
    newConcept: null,
    loading:true
}
//types
const LIST_TYPE = 'LIST_TYPE'
const LIST_AUX = 'LIST_AUX'
const LIST_CONCEPT = 'LIST_CONCEPT'
const CREATE_TYPE = 'CREATE_TYPE'
const CREATE_CONCEPT = 'CREATE_CONCEPT'
const DELETE_TYPE = 'DELETE_TYPE'
const UPDATE_TYPE = 'UPDATE_TYPE'
const ERROR_TYPE = 'ERROR_TYPE'

//reducer
export default function typeReducer(state = dataType, action) {
    switch (action.type) {
        case LIST_TYPE:
            return { ...state, types: action.payload };
        case LIST_AUX:
            return { ...state, lsType: action.payload ,loading:false};
        case LIST_CONCEPT:
            return { ...state, concepts: action.payload };
        case CREATE_TYPE:
            return { ...state, createType: action.payload };
        case DELETE_TYPE:
            return { ...state, deleteType: action.payload };
        case UPDATE_TYPE:
            return { ...state, updateType: action.payload };
        case ERROR_TYPE:
            return { ...state, errorType: action.payload };
        case CREATE_CONCEPT:
            return { ...state, newConcept: action.payload };
        default:
            return { ...state };
    }
}
export const findByConcept = (conceptName) => async (dispatch) => {
    const response = await service.findByConcept(conceptName).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.code !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: LIST_TYPE,
            payload: []
        });

    } else {
        let data = [];
        response.forEach((element) => {
            data.push({
                value: element.id,
                label: element.name.toUpperCase(),
                code: element.code
            });
        });

        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: LIST_TYPE,
            payload: data
        });
    }
}
export const getValuByConcept = (conceptName) => async (dispatch) => {
    const response = await service.findByConcept(conceptName).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.code !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: LIST_AUX,
            payload: []
        });

    } else {
        let data = [];
        response.forEach((element) => {
            data.push({
                value: element.value,
                label: element.name.toUpperCase(),
            });
        });

        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: LIST_AUX,
            payload: data
        });
    }
}

export const findTypeByConcept = (username, concept) => async (dispatch) => {
    const response = await service.getTypeByConcept(username, concept).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: LIST_TYPE,
            payload: []
        });
    } else {

        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: LIST_TYPE,
            payload: response
        });
    }

}

export const findAllConcepts = () => async (dispatch) => {
    let data = [];
    let response = await service.getConcepts().then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    console.log(response)
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: LIST_CONCEPT,
            payload: []
        });
    } else {
        response.forEach((element) => {
            data.push({
                value: element.id,
                label: element.name.toUpperCase(),
            });
        });
        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: LIST_CONCEPT,
            payload: data
        });
    }


    dispatch({
        type: LIST_CONCEPT,
        payload: data
    });
    return data;
}

export const createType = (type, username) => async (dispatch) => {
    const response = await service.getCreateType(type, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: CREATE_TYPE,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: CREATE_TYPE,
            payload: response
        });
    }
    return response;
}

export const deleteType = (lsData, username) => async (dispatch) => {
    const response = await service.getDeleteType(lsData, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.error !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: DELETE_TYPE,
            payload: []
        });
    } else {
        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: DELETE_TYPE,
            payload: response
        });
    }

    return response;
}

export const updateType = (type, username) => async (dispatch) => {
    const response = await service.getUpdateType(type, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.error !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: UPDATE_TYPE,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: UPDATE_TYPE,
            payload: response
        });
    }

    return response;
}

export const createConcept = (concept, username) => async (dispatch) => {
    const response = await service.saveConcept(concept, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_TYPE,
            payload: response
        });
        dispatch({
            type: CREATE_CONCEPT,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_TYPE,
            payload: ''
        });
        dispatch({
            type: CREATE_CONCEPT,
            payload: response
        });
    }
    return response;
}